import { render, staticRenderFns } from "./ListItakusaki.vue?vue&type=template&id=1129caa8&"
import script from "./ListItakusaki.vue?vue&type=script&lang=ts&"
export * from "./ListItakusaki.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports